import React from 'react';
import { Helmet } from 'react-helmet';

const CommercialInfo: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>Abonamente & implementare</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Abonamente & implementare</h1>
        <p className="text-sm text-muted-foreground">Ultima actualizare: 11 februarie 2026</p>
      </div>

      <section className="rounded-lg border border-border bg-card p-4 text-sm text-muted-foreground space-y-3">
        <p>
          Platforma <span className="text-foreground">Scola</span> poate fi utilizată:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <span className="text-foreground">B2C (utilizatori individuali)</span>: acces pe bază de cont și planuri
            (Free/Basic/Full), în funcție de funcționalitățile disponibile în Platformă la momentul utilizării.
          </li>
          <li>
            <span className="text-foreground">B2B (școli/unități)</span>: implementare personalizată pe baza unei oferte și
            a unui contract separat (inclusiv DPA).
          </li>
        </ul>
        <p>
          Pentru ofertă B2B, implementare la nivel de școală sau întrebări despre planuri, contactează-ne la{' '}
          <span className="text-foreground">office@globallinknet.ro</span>.
        </p>
      </section>

      <section className="rounded-lg border border-border bg-muted p-4 text-xs text-muted-foreground">
        Notă: detaliile comerciale (prețuri, durate, facturare, condiții de denunțare, etc.) pot varia în funcție de
        implementare și vor fi comunicate în ofertă/contract (B2B) sau în interfața de abonamente (B2C), după caz.
      </section>
    </div>
  );
};

export default CommercialInfo;

